import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';

import { RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';

const View: React.SFC<any> = _props => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <Row>
            <Col md={12}>
              <h4>Zaměstnanec</h4>
            </Col>
            <Col md={12}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                label={''}
                name={'employeeId'}
                id={'employeeId'}
                url={'/metropolis/api/hr/employees'}
                valueFunction={o => get(o, 'id')}
                labelFunction={o => get(o, 'fullName')}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <h4>Role</h4>
            </Col>
            <Col md={12}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                label={''}
                name={'roleId'}
                id={'roleId'}
                url={'/metropolis/api/roles'}
                valueFunction={o => get(o, 'id')}
                labelFunction={o => get(o, 'name')}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Grid>
    <Divider />
  </div>
);
export const RolesAssignFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/roles-assing/RolesAssignFormBasic.tsx